import type { TOC } from '@ember/component/template-only';

import DataManagerDatasetsComponent from 'webapp/components/data-manager/datasets';

const DatamanagerDatasetsRouteTemplate: TOC<object> = <template>
	<DataManagerDatasetsComponent />
</template>;

export default DatamanagerDatasetsRouteTemplate;
